module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0066.jpg?v=df3f7085";